import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import SharedFolderDropdown, {
  Props as FolderDropdownProps,
} from '@wix/da-shared-react/pkg/GallectionFolderDropdown';
import { useNonEmptyGallectionFolders } from '../../../hooks/useGallectionFolders';
import { setSelectedFolderId } from '../../../../../../actions/gallectionSection';

export interface Props
  extends Omit<
    FolderDropdownProps,
    | 'id'
    | 'folders'
    | 'hasMore'
    | 'fetchMore'
    | 'isLoading'
    | 'setSelectedFolderId'
  > {}

const FolderBarFolderDropdown: React.FC<Props> = props => {
  const dispatch = useDispatch();
  const {
    folders,
    hasMore,
    isFetching,
    fetchAll,
  } = useNonEmptyGallectionFolders();
  const handleSetSelectedFolderId = useCallback(
    number => {
      if (window) {
        window.scrollTo(0, 0);
      }
      dispatch(setSelectedFolderId(number));
    },
    [dispatch]
  );

  return (
    <SharedFolderDropdown
      {...props}
      id={'folders-dropdown'}
      folders={folders}
      hasMore={hasMore}
      isLoading={isFetching}
      fetchMore={fetchAll}
      setSelectedFolderId={handleSetSelectedFolderId}
    />
  );
};
FolderBarFolderDropdown.displayName = 'FolderBarFolderDropdown';

export default FolderBarFolderDropdown;
